
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/actuary/examUpdateGuide",
      function () {
        return require("private-next-pages/actuary/examUpdateGuide.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/actuary/examUpdateGuide"])
      });
    }
  